module.exports = __webpack_public_path__ + "fonts/YekanBakhFaNumHeavy.c467a6c.ttf";